import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataAmo: localStorage.getItem("dataAmo")
    ? JSON.parse(localStorage.getItem("dataAmo"))
    : null,
  updateDataAmo: null,
  newDataAmo: null,
  activeDataAmo: localStorage.getItem("activeAmo")
    ? JSON.parse(localStorage.getItem("activeAmo"))
    : null,
  isUpdateAmo: false,
  isLoadingAmo: false,
  isErrorAmo: false,
};

const amoSlice = createSlice({
  name: "amo",
  initialState,
  reducers: {
    setDataAmo(state, action) {
      state.dataAmo = action.payload;
    },
    setNewDataAmo(state, action) {
      state.newDataAmo = action.payload;
    },
    setUpdateDataAmo(state, action) {
      state.updateDataAmo = action.payload;
    },
    setIsUpdateAmo(state, action) {
      state.isUpdateAmo = action.payload;
    },
    setIsLoadingAmo(state, action) {
      state.isLoadingAmo = action.payload;
    },
    setActiveDataAmo(state, action) {
      state.activeDataAmo = action.payload;
    },
    setIsErrorAmo(state, action) {
      state.isErrorAmo = action.payload;
    },
  },
});

export const {
  setDataAmo,
  setNewDataAmo,
  setUpdateDataAmo,
  setIsUpdateAmo,
  setActiveDataAmo,
  setIsLoadingAmo,
  setIsErrorAmo,
} = amoSlice.actions;

export default amoSlice.reducer;
